const aliases = {
  Sopa: 'Petroleo',
  Petroleo: 'Sopa',
}

export function getRecipeColor(color) {
  return aliases[color] || color
}
